import React, {useContext} from 'react';
import {ModalContext} from '../../../context-providers/ModalProvider';
import {observer} from 'mobx-react';
import './StakeButtons.scss';
import NereusButton from '../../NereusButton/NereusButton';
import {useSwitchChainToBase} from "../../../hooks/useSwitchChainToBase";
// eslint-disable-next-line react/jsx-pascal-case
import NRS_USDC_LP_StakeDialog from '../../modals/NRS_USDC_LP_StakeDialog/NRS_USDC_LP_StakeDialog';
// eslint-disable-next-line react/jsx-pascal-case
import NRS_USDC_LP_WithdrawDialog from '../../modals/NRS_USDC_LP_WithdrawDialog/NRS_USDC_LP_WithdrawDialog';

const StakeButtons: any = observer(() => {
    const { openModal } = useContext(ModalContext);

    const switchChainToBase = useSwitchChainToBase();

    const handleOpenStakeModal = async () => {
        try {
            await switchChainToBase()
            // eslint-disable-next-line react/jsx-pascal-case
            openModal(<NRS_USDC_LP_StakeDialog/>)
        } catch (err) {
            console.error("Stake error", err)
        }
    };
    const handleOpenWithdrawModal = async () => {
        try {
            await switchChainToBase()
            // eslint-disable-next-line react/jsx-pascal-case
            openModal(<NRS_USDC_LP_WithdrawDialog/>)
        } catch (err) {
            console.error("Withdraw error", err)
        }
    };
    // const handleImportTokenModal = async () => {
    //     try {
    //         await window.ethereum.request({
    //             method: "wallet_watchAsset",
    //             params: {
    //                 type: "ERC20",
    //                 options: {
    //                     address: contractAddresses.base.veNrs,
    //                     symbol: await veNrsContract.read.symbol(),
    //                     decimals: 18,
    //                     image: `${window.location.origin}/assets/crypto-icons/nrs.svg`,
    //                 },
    //             },
    //         });
    //     } catch (err) {
    //         console.error("handleImportTokenModal error", err)
    //     }
    // };

    return (
        <div className="StakeButtons">
            <div className="flex gap-4">
                <NereusButton className="flex-1" variant="contained" onClick={handleOpenStakeModal}>
                    Stake
                </NereusButton>
                <NereusButton className="flex-1" variant="outlined" color="secondary" onClick={handleOpenWithdrawModal}>
                    Unstake
                </NereusButton>
                {/*<NereusButton style={{maxWidth: '36.5px', minWidth: '36.5px', padding: 0}} variant="outlined" color="secondary" onClick={handleImportTokenModal}>*/}
                {/*    <WalletIcon/>*/}
                {/*</NereusButton>*/}
            </div>
        </div>
    );
});

export default StakeButtons;
